//import React from 'react';
//import { makeStyles } from "@mui/styles";
import {Card, CardContent, Box, CardHeader} from "@mui/material";
//import ASPECStyles from "../../../../../styles/jss/components/apps/ASPECStyles";

//const useStyles = makeStyles(ASPECStyles);

const FlightSegmentDef = props => {
    //const classes = useStyles();

    return(
        <Card style={{height: '100%'}}>
            <CardHeader
                title={'Mission Flight Segment Definition'}
                sx={{
                  "&": {
                    padding: '16px 16px 0 16px',
                    alignItems: 'flex-start'
                  }
                }}
                slotProps={{
                  title: {
                    fontSize: '20px'
                  }
                }}
            />
            <CardContent style={{height: '80%', display: 'flex'}}>
                <Box
                  component="img"
                  sx={{
                    width: '100%'
                  }}
                  src={"/MissionFlightSegmentDefinition.svg"}
                  alt="Mission Flight Segment Definition"
                />
            </CardContent>
        </Card>
    )
}

export default FlightSegmentDef;